<div class="card mt-1">
  <div class="card-body">
    <div class="row">
      <div class="col"><h4>Patient Prescriptions</h4></div>
      <div class="col text-end">
        <div class="d-inline-flex justify-content-around align-items-center">
          <div class="legend-block high-value me-1 rounded"></div>
          <div class="me-2">High value</div>
          <div class="legend-block rejected me-1 rounded"></div>
          <div>Rejected/Reversed</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (filterByPrescriber) {
          <div class="alert alert-primary">
            Only showing prescriptions prescribed by <strong>{{ capture.provider.fullName }}</strong>
          </div>
        }
        <app-prescription-list
          [activePrescriptionId]="activePrescriptionId"
          [activeCaptureId]="activeCaptureId"
          [prescriptions]="prescriptions"
          [fixedHeader]="fixedHeader"
          />
      </div>
    </div>
  </div>
</div>
